import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin({
  name: 'app:sentry-unleash',
  dependsOn: ['unleash:plugin'],
  setup() {
    const { enabled } = useRuntimeConfig().public.sentry

    if (!enabled) return

    watchImmediate(useFeatures({ all: true }), (features) => {
      Sentry.setTags(
        Object.fromEntries(features.map(mapFeatureToSentryTagEntry)),
      )
    })
  },
})
